@import '~style-sheet-helpers/core.less';
@import '../authentication.module.less';
@import '../../app-brand/entities/entity-layer.module.less';

.resend-verification-form {
  color: @authentication--text-color;
}

.resend-verification-form-title {
  text-align: center;
  margin: 15px 0;
  font-size: 17px;
}

.error-message {
  margin: 10px 0;
  background: @authentication--error--background-color;
  border: 1px solid @authentication--error--border-color;
  font-size: 13px;
  color: @authentication--error--text-color;
  border-radius: 4px;
  padding: 10px;
}

.form-inputs {
  margin-bottom: 15px;

  > div {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.resend-verification-buttons {
  display: flex;
  flex-direction: row-reverse;
}
